import { useDispatch, useSelector } from 'react-redux'
import {
  selectActiveAddress,
  selectPceSearchData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSelectors'
import {
  updateGasMeterAddressData,
  updatePceSearchData,
} from '@/containers/SubscriptionFormPageNew/SubscriptionForm/SubscriptionFormSlice'
import {
  PulseSearchModalOverrides,
  SearchModalOverrides,
} from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/styled-components'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'

const usePceSearchV2 = () => {
  const isPulse = usePulseScope()
  const dispatch = useDispatch()
  const activeAddress = useSelector(selectActiveAddress)
  const {
    address,
    viewPage,
    occupant,
    pceSelected,
    serialNumber,
    searchPodResponses,
    searchPodResponsesOriginal,
    isOpen,
    isLoading,
    page,
  } = useSelector(selectPceSearchData)

  const { zipcode = '', inseeCode = '', city = '', streetNumber = '', streetName = '' } = address

  const resetPceSearchData = () => {
    dispatch(
      updatePceSearchData({
        searchPodResponses: [],
        searchPodResponsesOriginal: [],
        viewPage: 'search',
        address: {},
        occupant: '',
        serialNumber: '',
        page: 1,
        errorMessage: null,
        podSearchDataId: null,
      }),
    )
  }

  const updateList = results => {
    dispatch(
      updatePceSearchData({
        searchPodResponses: results,
        searchPodResponsesOriginal: results,
        triggerSearchPod: false,
        page: 1,
      }),
    )
  }

  const updatePceConfigData = payload => {
    dispatch(updatePceSearchData(payload))
  }

  const updatePce = pceNo => {
    dispatch(updateGasMeterAddressData({ data: { pceNo }, id: 'activeAddress' }))
  }

  const updateAddressHandler = address => {
    if (!address) {
      dispatch(updatePceSearchData({ address: {} }))
      return
    }
    dispatch(
      updatePceSearchData({
        address: address[0] ?? {
          streetName: '',
          label: '',
          city: '',
          inseeCode: '',
          zipcode: '',
          streetNumber: '',
          type: '',
        },
      }),
    )
  }
  const isFormFilled = Object.keys(address).length > 0 && (occupant?.length > 0 || serialNumber?.length > 0)

  const handlePageChange = nextPage => {
    if (nextPage < 1) {
      return
    }
    if (nextPage > Math.ceil(searchPodResponses.length / 8)) {
      return
    }
    dispatch(updatePceSearchData({ page: nextPage }))
  }

  const handleSelectPce = pceData => {
    dispatch(
      updateGasMeterAddressData({
        data: {
          pceNo: pceData.pce || pceData.pod_id,
          isValidPce: true,
          meterConsent: false,
          consentDate: null,
        },
        id: activeAddress,
      }),
    )
    updatePceConfigData({ isOpen: false })
    resetPceSearchData()
  }

  const handleBackToSearch = () => {
    updatePceConfigData({ viewPage: 'search' })
  }

  return {
    isFormFilled,
    modalOverrides: isPulse ? PulseSearchModalOverrides : SearchModalOverrides,
    currentViewPage: viewPage,
    getAddress: address,
    getZipCode: zipcode,
    getInseeCode: inseeCode,
    getCity: city,
    getOccupant: occupant,
    getSerialNumber: serialNumber,
    currentSelectedOption: pceSelected,
    searchPodResponses,
    searchPodResponsesOriginal,
    getStreetNumberName: `${streetNumber} ${streetName}`.trim(),
    getStreetNumber: streetNumber,
    getStreetName: streetName,
    resetPceSearchData,
    isOpen,
    isLoading,
    updateList,
    updatePceConfigData,
    updateAddressHandler,
    updatePce,
    handlePageChange,
    page,
    handleSelectPce,
    handleBackToSearch,
  }
}

export default usePceSearchV2
